import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../constants/common'
import { useKeyboard } from '../../../hooks'
import { ConfirmationModal } from '../../Confirmation'
import { getGretaAIChatProjectDeleteDescription } from '../GretaAIChat.utils.projects'

function GretaAIChatProjectDeleteConfirmation({
  isGenerating = false,
  project,
  onCancel,
  onConfirm,
}) {
  const {
    i18n: { language },
    t,
  } = useTranslation()

  useKeyboard(null, onCancel)

  const [hasError, setHasError] = useState(false)

  async function handleSubmit() {
    setHasError(false)

    try {
      await onConfirm()
    } catch {
      setHasError(true)
    }
  }

  return (
    <ConfirmationModal
      actionButtonsProps={{ submitText: t('Greta.ProjectDeleteConfirmKey') }}
      description={getGretaAIChatProjectDeleteDescription({
        isGenerating,
        language,
        project,
        t,
      })}
      notifications={
        hasError
          ? [
              {
                text: t('Greta.ProjectDeleteErrorKey'),
                type: NOTIFICATION_TYPE.error,
              },
            ]
          : null
      }
      title={t('Greta.ProjectDeleteTitleKey')}
      onCancel={onCancel}
      onSubmit={handleSubmit}
    />
  )
}

export default GretaAIChatProjectDeleteConfirmation
